import { Component, ElementRef } from '@angular/core';
import { getElementHeight } from '@df/dom/fn/get-element-height';

@Component({
    selector: 'tray-handle',
    template: `<div class="handle"></div>`,
    styles: [
        `
            :host {
                display: block;
                position: relative;
                padding: 0.5em 0;
                text-align: center;
            }

            .handle {
                display: inline-block;
                background-color: white;
                width: 5em;
                height: 2px;
                box-shadow: 0px 2px 8px 0px rgba(102, 102, 102, 0.15);
            }
        `
    ],
    standalone: true
})
export class TrayHandleComponent {
    /**
     * Dependencies
     */
    constructor(private elementRef: ElementRef) {}

    get height(): number {
        return Math.floor(getElementHeight(this.elementRef.nativeElement));
    }
}
